// extracted by mini-css-extract-plugin
module.exports = {"miscellaneous_data_modal":"AddLineModal_miscellaneous_data_modal__3k2QM"};